import { render } from "./IconDropdown.vue?vue&type=template&id=5d6c373f"
const script = {}

import exportComponent from "/builds/sats/careers-application/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__